import React, { useCallback, useEffect, useState } from 'react';
import KoobTitle from '../../../components/Koob/KoobTitle';
import { useTranslation } from 'react-i18next';
import LibraryFilters from './LibraryFilters';
import LibraryActiveFilters from './LibraryActiveFilters';
import TripCard from 'components/Trip/TripCard';
import TripList, { buildTripRequestFilters } from 'components/Trip/TripList';
import { useAsync } from 'react-async';
import { getTags } from '../../../api/tag';
import KoobLayout from '../../../components/Koob/KoobLayout';
import { useLibraryFilters, useSetLibraryFilters } from '@koob/trip-designer';

function TripTypeButton({ type, label, bookingsType, setBookingsType, icon }) {
  return (
    <div
      className={[
        'flex gap-2 mt-2 py-2 px-3 text-base font-medium rounded-xl border hover:border-gray-500 border-gray-300 transition ease-in bg-white',
        bookingsType === type
          ? 'bg-gradient-to-b from-k-gd1 to-k-gd2 text-white'
          : 'text-gray-500',
      ].join(' ')}
      onClick={() => setBookingsType(type)}
    >
      {icon}
      {label}
    </div>
  );
}

export default function TripsList() {
  const { t } = useTranslation('tripDesigner');
  const libraryFilters = useLibraryFilters();
  const setLibraryFilters = useSetLibraryFilters();

  const [tags, setTags] = useState([]);
  const { data: tagsData, reload: reloadTags } = useAsync({
    promiseFn: getTags,
    scope: 'Trip',
  });

  useEffect(() => {
    setTags(tagsData?.data ?? []);
  }, [tagsData]);

  const updateFilterValue = useCallback(
    (property, value) => {
      setLibraryFilters(current => ({
        ...current,
        [property]: value,
      }));
    },
    [setLibraryFilters],
  );

  const type = libraryFilters?.type ?? 'trip';

  return (
    <KoobLayout>
      <div className="flex flex-col">
        <LibraryFilters tags={tags} />

        <LibraryActiveFilters style={{ marginTop: '1rem' }} />

        <div className="flex justify-between items-center">
          <KoobTitle size="text-2xl">{t('library.title')}</KoobTitle>

          <div className="flex space-x-1">
            <TripTypeButton
              type={'trip'}
              label="Trips"
              bookingsType={type}
              setBookingsType={value => updateFilterValue('type', value)}
            />
            <TripTypeButton
              type={'template'}
              label="Templates"
              bookingsType={libraryFilters?.type}
              setBookingsType={value => updateFilterValue('type', value)}
            />
          </div>
        </div>

        <div className="mt-3">
          <TripList
            filters={buildTripRequestFilters(libraryFilters, {
              type,
              onlyFavorites: libraryFilters?.onlyFavorites ?? false,
            })}
            renderCount={count => (
              <h6 className="mt-4 mb-3 text-gray-500">
                {t('library.results', { count })}
              </h6>
            )}
            renderCard={(trip, reload) => (
              <TripCard
                trip={trip}
                reload={reload}
                enableChat={type === 'trip'}
                enableFavorite
                enableTagsEdition
                enableExport
                enableReceipt={type === 'trip'}
                tags={tags}
                reloadTags={reloadTags}
              />
            )}
          />
        </div>
      </div>
    </KoobLayout>
  );
}
